import { LANG, TAGS_VIEW } from '../../constant/index'
import { getItem, setItem } from '@/utils/storage'
export default {
  namespaced: true,
  state: () => ({
    sidebarOpened: true,
    language: getItem(LANG) || 'zh',
    tagsViewList: getItem(TAGS_VIEW) || []
  }),
  mutations: {
    triggerSidebarOpened(state) {
      state.sidebarOpened = !state.sidebarOpened
    },
    setLanguage(state, lang) {
      state.language = lang
      setItem(LANG, lang)
    },
    addTagsViewList(state, route) {
      // 判断该路由是否已经存在在页面上
      const isExist = state.tagsViewList.some(item => item.path === route.path)
      // 如果不存在则添加
      if (!isExist) {
        state.tagsViewList.push(route)
        setItem(TAGS_VIEW, state.tagsViewList)
      }
    },
    changeTagsView(state, { index, tag }) {
      state.tagsViewList[index] = tag
      setItem(TAGS_VIEW, state.tagsViewList)
    },
    removeTagsView(state, { type, index }) {
      if (type === 'index') {
        // 指定关闭
        state.tagsViewList = state.tagsViewList.filter((item, idx) => idx !== index)
      } else if (type === 'other') {
        // 关闭其他
        state.tagsViewList = state.tagsViewList.filter((item, idx) => idx === index)
      } else {
        // 关闭右侧
        state.tagsViewList = state.tagsViewList.filter((item, idx) => idx <= index)
      }
      setItem(TAGS_VIEW, state.tagsViewList)
    }

  },
  actions: {}
}
